import { Result } from "domain/entities/result";
import { MethodRepository } from "domain/repositories";

export default class DeleteUseCase {
    private methodRepository: MethodRepository;
    
    public constructor(methodRepository: MethodRepository) {
        this.methodRepository = methodRepository
    }

    public async deleteMethod(id: number, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.methodRepository.deleteMethod(id, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}